import { useState, useEffect } from "react";
import { paymentInfo, paymentCredentails } from "../store/nanostore";
import { useStore } from "@nanostores/react";
import { fetchAndLinkAccounts } from "./fetchAndLinkStripe";

//TODO - this function should be under services and be imported here, also use switch to determine the link method like stripe or plaid
export const useLinkPayment = (type: string) => {
  const $paymentInfo = useStore<any>(paymentInfo);
  const $paymentCredentails = useStore<any>(paymentCredentails);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);
  const loadAccount = async (secret?: string) => {
    try {
      if ($paymentInfo.existingUser) {
        return; // Handle existing user case
      }
      if (!$paymentCredentails && !secret) {
        throw "Invalid payment credentails.";
      }
      setIsLoading(true);
      switch (type) {
        case "plaid":
        case "stripe":
        default:
          const data: any = await fetchAndLinkAccounts(
            secret || $paymentCredentails.stripeClientSecret
          );

          setIsSuccess(data && data?.length > 0);
      }
    } catch (error: any) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    status: !error && !isLoading,
    error,
    isLoading,
    loadAccount,
    isSuccess,
  };
};
